import "antd-mobile/dist/antd-mobile.css"
import "antd/dist/antd.css"
import classNames from "classnames"
import React from "react"
import ReactPixel from "react-facebook-pixel"
import ReactGA from "react-ga"
import TwitterConvTrkr from "react-twitter-conversion-tracker-plus"

import { hot } from "react-hot-loader"
import { Provider } from "react-redux"
import { Route, BrowserHistory } from "react-router"
import { Router, Switch } from "react-static"
import "./app.css"
import { Footer } from "./components/Footer"
import Nav from "./components/Nav"
import store from "./connectors/redux"
import Routes from "./Routes"

typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  ReactGA.initialize("UA-129791229-1")

const pixelOptions = {
  autoConfig: true, // set pixel's autoConfig
  debug: false // enable logs
}
typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  ReactPixel.init("261584891135812", {}, pixelOptions)

typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  TwitterConvTrkr.init("o275n")

const App = () => (
  <Provider store={store}>
    <Router history={BrowserHistory}>
      <div>
        {TwitterConvTrkr.pageView()}
        <Nav style={{ marginBottom: 10 }} />
        <Route>
          {({ location }) => (
            <React.Fragment>
              <div
                id="wrapper"
                className={classNames("ui container", {
                  registerContainer:
                    typeof location.pathname !== "undefined" &&
                    location.pathname.includes("/register")
                })}
              >
                {location.pathname !== "undefined" &&
                  ReactGA.pageview(location.pathname + location.search)}
                {location.pathname !== "undefined" && ReactPixel.pageView()}
                <div
                  className={classNames(
                    "ui segment mobile-segment-with-padding",
                    {
                      "mobile-segment":
                        (typeof location.pathname !== "undefined" &&
                          location.pathname.includes("/ranking")) ||
                        location.pathname.includes("/run-status")
                    }
                  )}
                >
                  <div className="ui one column grid">
                    <div className="column">
                      <Route>
                        {({ location }) => (
                          <Switch location={location}>
                            <Routes />
                          </Switch>
                        )}
                      </Route>
                    </div>
                  </div>
                </div>
                <Footer />
              </div>
            </React.Fragment>
          )}
        </Route>
      </div>
    </Router>
  </Provider>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js